import React from 'react'

/**
 * 生成带必填星号的 label
 * @param label - 原始 label（可以是字符串或 ReactNode）
 * @param required - 是否为必填项
 * @returns 带星号的 label
 */
export const createFormLabel = (
  label: string | React.ReactNode,
  required: boolean = false,
): React.ReactNode => {
  if (!required) {
    return label
  }
  
  return (
    <>
      {label}
      <span className='text-red-500 ml-1'>*</span>
    </>
  )
}

